// // Utilitários de carrinho (localStorage + evento "cart-updated")

// const STORAGE_KEY = "cart_v1";

// /** Lê e normaliza itens */
// export function getCart() {
//   try {
//     const raw = localStorage.getItem(STORAGE_KEY);
//     const arr = raw ? JSON.parse(raw) : [];
//     return Array.isArray(arr)
//       ? arr.map((it) => ({
//           id: it.id,
//           sku: it.sku ?? it.id,
//           title: it.title ?? it.name ?? "",
//           price: Number(it.price) || 0,
//           qty: Math.max(1, Number(it.qty) || 1),
//           image: it.image?.src || it.image || "",
//         }))
//       : [];
//   } catch {
//     return [];
//   }
// }

// function saveCart(items) {
//   try {
//     localStorage.setItem(STORAGE_KEY, JSON.stringify(items || []));
//   } catch {}
//   // notifica navbar/badges e outras abas
//   try {
//     window.dispatchEvent(new Event("cart-updated"));
//   } catch {}
// }

// export function getCartCount() {
//   return getCart().reduce((n, it) => n + (Number(it.qty) || 0), 0);
// }

// export function getSubtotal() {
//   return getCart().reduce((sum, it) => sum + (Number(it.price) || 0) * (Number(it.qty) || 0), 0);
// }

// export function addItem(item, qty = 1) {
//   const n = Math.max(1, Number(qty) || 1);
//   const items = getCart();
//   const i = items.findIndex((p) => String(p.id) === String(item.id));
//   if (i >= 0) {
//     items[i].qty = Math.max(1, (Number(items[i].qty) || 1) + n);
//   } else {
//     items.push({
//       id: item.id,
//       sku: item.sku ?? item.id,
//       title: item.title ?? item.name ?? "",
//       price: Number(item.price) || Number(item.priceNumber) || 0,
//       qty: n,
//       image: item.image?.src || item.image || item.images?.[0] || "",
//     });
//   }
//   saveCart(items);
// }

// export function setQty(id, qty) {
//   const n = Math.max(1, Number(qty) || 1);
//   const items = getCart().map((p) => (String(p.id) === String(id) ? { ...p, qty: n } : p));
//   saveCart(items);
// }

// export function removeItem(id) {
//   const items = getCart().filter((p) => String(p.id) !== String(id));
//   saveCart(items);
// }

// export function clearCart() {
//   try {
//     localStorage.removeItem(STORAGE_KEY);
//   } catch {}
//   try {
//     window.dispatchEvent(new Event("cart-updated"));
//   } catch {}
// }

// /**
//  * initCart — compat / no-op
//  * - (Opcional) migra chaves antigas se existirem
//  * - dispara um "cart-updated" para hidratar badges na app
//  */
// export function initCart() {
//   try {
//     // exemplo de migração simples (se tinhas um nome antigo):
//     const OLD_KEY = "cart";
//     const old = localStorage.getItem(OLD_KEY);
//     const hasNew = localStorage.getItem(STORAGE_KEY);
//     if (old && !hasNew) {
//       localStorage.setItem(STORAGE_KEY, old);
//       localStorage.removeItem(OLD_KEY);
//     }
//   } catch {}
//   // notifica já no arranque
//   try {
//     window.dispatchEvent(new Event("cart-updated"));
//   } catch {}
// }
// Utilitários de carrinho (localStorage + evento "cart-updated")

const STORAGE_KEY = "cart_v1";

/** Lê e normaliza itens */
export function getCart() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr)
      ? arr.map((it) => ({
          id: it.id,
          sku: it.sku ?? it.id,
          title: it.title ?? it.name ?? "",
          price: Number(it.price) || 0,
          qty: Math.max(1, Number(it.qty) || 1),
          image: it.image?.src || it.image || "",
        }))
      : [];
  } catch {
    return [];
  }
}

function saveCart(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items || []));
  } catch {}
  // notifica navbar/badges e outras abas
  try {
    window.dispatchEvent(new Event("cart-updated"));
  } catch {}
}

export function getCartCount() {
  return getCart().reduce((n, it) => n + (Number(it.qty) || 0), 0);
}

export function getSubtotal() {
  return getCart().reduce(
    (sum, it) => sum + (Number(it.price) || 0) * (Number(it.qty) || 0),
    0
  );
}

export function addItem(item, qty = 1) {
  const n = Math.max(1, Number(qty) || 1);
  const items = getCart();
  const i = items.findIndex((p) => String(p.id) === String(item.id));
  if (i >= 0) {
    items[i].qty = Math.max(1, (Number(items[i].qty) || 1) + n);
  } else {
    items.push({
      id: item.id,
      sku: item.sku ?? item.id,
      title: item.title ?? item.name ?? "",
      price: Number(item.price) || Number(item.priceNumber) || 0,
      qty: n,
      image: item.image?.src || item.image || item.images?.[0] || "",
    });
  }
  saveCart(items);
}

export function setQty(id, qty) {
  const n = Math.max(1, Number(qty) || 1);
  const items = getCart().map((p) =>
    String(p.id) === String(id) ? { ...p, qty: n } : p
  );
  saveCart(items);
}

export function removeItem(id) {
  const items = getCart().filter((p) => String(p.id) !== String(id));
  saveCart(items);
}

export function clearCart() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {}
  try {
    window.dispatchEvent(new Event("cart-updated"));
  } catch {}
}

/**
 * initCart — compat / no-op
 * - (Opcional) migra chaves antigas se existirem
 * - dispara um "cart-updated" para hidratar badges na app
 */
export function initCart() {
  try {
    // exemplo de migração simples (se tinhas um nome antigo):
    const OLD_KEY = "cart";
    const old = localStorage.getItem(OLD_KEY);
    const hasNew = localStorage.getItem(STORAGE_KEY);
    if (old && !hasNew) {
      localStorage.setItem(STORAGE_KEY, old);
      localStorage.removeItem(OLD_KEY);
    }
  } catch {}
  // notifica já no arranque
  try {
    window.dispatchEvent(new Event("cart-updated"));
  } catch {}
}

// ALIAS opcional para quem preferir este nome:
export const setItemQty = setQty;
